import styled from "styled-components";
import colors from "../../../../shared/theme/colors";

export const CardTipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${colors.dicaText};
  width: 100%;
  height: 126px;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid ${colors.dicaBorder};
  border-radius: 12px;

  .card-tips-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 17px;
    font-weight: 700;
    line-height: 1;
  }

  .card-tips-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  .card-tips-text {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.4;
  }

  @media (min-width: 768px) {
    padding: 12px;
  }
`;
